<template>
  <small :style="input_style">
    <span :style="length > limit - 10 ? 'color: #e74a3b;' : ''">{{ length }}</span> / {{ limit }} {{ !hidden_text ? getTranslations('expression_655') : '' }}
  </small>
</template>

<script>
export default {
  name: "TextCount",
  props: ['length', 'limit', 'input_style', 'hidden_text']
}
</script>

<style scoped>

</style>
